<template>
  <v-form ref="modifierEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'modifier-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{this.id ? 'Редактирование ингредиента' : 'Создание ингредиента'}}</h1>
      </v-col>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang">
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                        v-model="modifier.name"
                        label="Название"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                        v-model="modifier.name_ua"
                        label="Название"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-select
                :items="categories"
                :item-text="category => category.name"
                :item-value="category => category"
                v-model="modifier.category"
                label="Категория"
                :rules="[rules.requiredSelect]"
                required
                return-object
                outlined
        ></v-select>
        <div class="mb-8">
          <v-img :src="previewImage(true, listImage)" width="90" height="68">
            <template v-slot:placeholder>
              <div class="image-placeholder"></div>
            </template>
          </v-img>
        </div>
        <v-file-input label="Картинка в список блюд"
                      prepend-icon=""
                      class="cursor-pointer"
                      outlined
                      placeholder="90x68.png"
                      append-icon="mdi-attachment"
                      v-model="listImage">
        </v-file-input>
        <div class="mb-8">
          <v-img :src="previewImage(false, constructorImage)" width="90" height="68">
            <template v-slot:placeholder>
              <div class="image-placeholder"></div>
            </template>
          </v-img>
        </div>
        <v-file-input label="Картинка в конструктор"
                      prepend-icon=""
                      class="cursor-pointer"
                      outlined
                      placeholder="500x500.png"
                      append-icon="mdi-attachment"
                      v-model="constructorImage">
        </v-file-input>
        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import ModifierService from './../../api/ModifierService'

  export default {
    name: 'ModifierEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      tab: '',
      tabLang: '',
      modifier: {
          name: '',
          name_ua: '',
          category: {},
      },
      listImage: null,
      constructorImage: null,
      loading: true,
      loadingButton: false,
      categories: [],
    }),
    mounted() {
        if(this.id) {
            ModifierService.get(this.id)
                .then(response => {
                    this.modifier = response.data;

                    if (this.modifier.image) {
                        this.listImage = this.modifier.image;
                        this.listImage.name = this.modifier.image.file
                    }
                    if (this.modifier.image_constructor) {
                        this.constructorImage = this.modifier.image_constructor;
                        this.constructorImage.name = this.modifier.image_constructor.file
                    }
                    this.loading = false
                });
        }
      ModifierService.getCategoryList().then(response => {
        this.categories = response.data
      });
    },
    methods: {
      validate() {
        this.$refs.modifierEditForm.validate()
        if(this.modifier.name == '' && this.modifier.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.modifier.name != '' && this.modifier.name_ua == ''){
          this.tabLang = 1;
        }
      },
      previewImage(isList, image) {
          if(isList){
              if(this.listImage && this.listImage.url){
                  return this.listImage.url
              }
          } else {
              if(this.constructorImage && this.constructorImage.url){
                  return this.constructorImage.url
              }
          }

        if(image){
          return URL.createObjectURL(image)
        }
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }

        this.loadingButton = true;
        let formData = this.getData();

        ModifierService.update(this.id, formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Ингредиент успешно обновлено';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении ингредиента';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        ModifierService.create(formData).then(response => {
            this.$router.push({ name: 'modifier-edit', params: { id: response.data.id } })
          this.modifier.id = response.id
          this.snackbar = true;
          this.snackbarText = 'Ингредиент создан';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при создании ингредиента';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();

          formData.append('name', this.modifier.name);
          formData.append('name_ua', this.modifier.name_ua);
          formData.append('modifier_category_id', this.modifier.category ? this.modifier.category.id : null);
          if(this.listImage && !this.listImage.url) {
              formData.append('listImage', this.listImage);
          }
          if(this.constructorImage && !this.constructorImage.url) {
              formData.append('constructorImage', this.constructorImage);
          }

          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .modifier-images .v-image{
    max-height: 374px;
  }
  .modifier{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
